import { render } from "./ButtonNextSection.vue?vue&type=template&id=49fd89a2"
import script from "./ButtonNextSection.vue?vue&type=script&lang=js"
export * from "./ButtonNextSection.vue?vue&type=script&lang=js"

import "./ButtonNextSection.vue?vue&type=style&index=0&id=49fd89a2&lang=scss"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__